












































import {
  checklistPostReq
} from "@/services/checklist.service";

export default {
  props: ['entryMachines', 'entryUID', 'companyId'],
  data() {
    return {
      filter1: null,
      machine_dialog: true,
      entry_machines: null,
      curr_index: null,
      lastSteps: -1,
      searchkey: "",
    }
  },
  watch: {
    machine_dialog: function (val, oldVal) {
      if (!val) {
        this.$emit("dialogClosed", true);
      }
    },
    key_pressed: function (val, oldVal) {
      if (val) {
        this.lastSteps = -1
      }
    },
    searchkey: function (nval, oval) {
      this.$store.state.machine_filter = nval
    }
  },
  computed: {
    appLang: function() {
      return this.$store.state.lang
  },
    key_pressed() {
      return this.$store.state.key_shift
    },
    sel_machines() {
      if (this.entry_machines) {
        return this.entry_machines
      }
      return [];
    },
    machines() {
      if (this.searchkey && this.searchkey.length > 0) {
        return this.$store.state.machines.filter(machine => {
          return (
            machine.text.toLowerCase().indexOf(this.searchkey.toLowerCase()) !==
            -1
          );
        });
      }
      return this.$store.state.machines;
    },
  },
  mounted() {
    this.entry_machines = this.entryMachines
    this.searchkey = this.$store.state.machine_filter

    console.log("companyId", this.companyId)
  },
  destroyed() {
    //console.log("destroyed")
  },
  methods: {
    closeDialog: function () {
      this.$emit("dialogClosed", true);
    },
    saveSelection: function () {

      checklistPostReq('machinegroups-updatemachines', {
          uid: this.entryUID,
          machines: this.entry_machines,
          myCompanyId: this.companyId
        })
        .then(resp => {
          this.$store.state.machines_group_list = resp.data.list
          this.$emit("dialogClosed", true);
        })
        .catch(e => {
          this.$store.dispatch("api_error", e);
        });

    },
    resetFilter: function () {
      this.searchkey = ""
    },
    resetSelection: function () {
      this.entry_machines.splice(0, this.entry_machines.length)
    },
    reverseSelection: function () {
     let new_entries = []

      for (let k of this.machines) {
        if ( !this.entry_machines.find(element => element == k.value) ) {
          new_entries.push(k.value)
        }
      }

      this.entry_machines = new_entries
    },
    activateSlot: function (item, force) {
      const idx = this.entry_machines.indexOf(item.value)

      //console.log("$store.state.key_shift", this.$store.state.key_shift, item, index)
      if (idx == -1) {
        if (force.add) {
          this.entry_machines.push(item.value)
        }

      } else {
        if (force.remove) {
          this.entry_machines.splice(idx, 1)
        }
      }
    },
    slotMachine: function (e, item, index) {
      e.preventDefault();

      let startIdx = 0;
      let steps = 0;

      if (this.key_pressed) {
        if (this.curr_index > index) {
          steps = this.curr_index - index
          startIdx = index
        }

        if (this.curr_index < index) {
          startIdx = this.curr_index
          steps = index - this.curr_index
        }

        if (steps > 0) {

          if (this.lastSteps > 0 && steps < this.lastSteps) {
            for (let index = this.lastSteps; index > steps; index--) {
              this.activateSlot(this.machines[index + startIdx], {
                add: false,
                remove: true
              })
            }
          }

          this.lastSteps = steps

          for (let index = startIdx; index <= startIdx + steps; index++) {
            this.activateSlot(this.machines[index], {
              add: true,
              remove: false
            })
          }

        } else {
          this.curr_index = index
          this.activateSlot(item, {
            add: true,
            remove: true
          })
        }
      } else {
        this.curr_index = index
        this.activateSlot(item, {
          add: true,
          remove: true
        })
      }

    },

  }
}
